<template>
  <div class="signup app-content bg-gray">
    <div class="container">
      <div class="row pt-4 ">
        <div class="col-12">
          <router-link :to="'./mypage'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
          </router-link> 
          <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
          <router-link :to="'./accept_certificate'">
            <p class="text-dark font14 under" style="display: inline;">{{$t("message.regist_accept_certificate")}}</p>
          </router-link> 
        </div>
      </div>
      <div class="row mt-4">
        <div class="container my-5" >
          <h2 class="title text-center">{{$t("message.registration_skill_visa")}}</h2>
        </div>
        <div v-if="isEmpty(memberInfo.accept_image_url)" class="col-12 col-md-8 mx-auto px-0 done text-center">
          <p class="mt-2 mb-2 ">{{$t("message.please_register_pdf_number")}}</p>
          <p class="mt-2 mb-2 ">{{$t("message.regist_and_get_cash_bag")}}</p>
          <img class="img-fluid mx-auto d-block w-50 pb-3 pt-3" src="../../../assets/top/PC/cashback_image.svg">
        </div>
        <div v-else class="col-12 col-md-8 mx-auto px-0 done text-center">
          <p class="mt-2 mb-2 ">{{$t("message.thank_you_regist_visa_pass")}}</p>
        </div>

         <div class="col-12 mb-5">
          <b-card>
            <validation-observer class="form bg-white" ref="obs" >
              <p class="mb-2">評価試験合格証又は技能実習修了証明書</p>
              <div class="row ">
                <div class="col-12 col-md-7">
                  <validation-provider name="accept" >
                    <div slot-scope="AcceptProps">
                      <div v-if='accept_name == "" || accept_name.match(/pdf/g) == null'>
                        <div id="upload" v-if="isEmpty(memberInfo.accept_image_url)" class="form-group commonStyle " v-bind:class="{'styleA':styleA, 'styleB':styleB , 'isImage':isAccept}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event) " :style="{background: 'url(' + accept_image + ')'}"> 
                          <label for="accept" class="button" :class='{"isImage":isAccept}' >
                            <p v-if='!isAccept' >＋</p>
                            <input id="accept" type="file" name="img" @change="uploadFile($event)" style="display:none;" accept="image/*,application/pdf">
                          </label>
                          <p v-if='!isAccept' >{{$t("message.click_upload")}}</p>
                          <p v-if='!isAccept'>{{$t("message.image_drop")}}</p>
                        
                        </div>
                        <div v-else>
                          <img class="img-c w-100" :src="memberInfo.accept_image_url"/>
                        </div>
                      </div>
                      <div v-else>
                        <a target="_blank" :href="accept_url">{{accept_name}} </a>
                      </div>
                      <p v-if="AcceptProps.failed" class="error">{{ AcceptProps.errors[0] }}</p>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <p class="mb-2">{{$t('message.accept_number')}}</p>
              <div class="row">
                <div class="col-12 col-md-5 pr-0 ">
                  <validation-provider name="number">
                    <div slot-scope="AcceptNumberProps">
                      <input class="dirty b-w-0 p-2 bg-gray width100" v-model="regist_info.accept_number">
                      <p v-if="AcceptNumberProps.failed" class="error">{{ AcceptNumberProps.errors[0] }}</p>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </validation-observer>

            <b-button  v-if="isEmpty(memberInfo.accept_image_url)" class="navLogin mt-4 px-5" @click='regist'>{{$t("message.save")}}</b-button>
          </b-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
import axios from 'axios';

export default {
  data () {
    return {
      styleA:true,
      styleB:false,
      idToken: localStorage.idToken,
      isAccept: false,
      accept_image: "",
      // fileValid: false,
      accept_name: "",
      accept_url: "",
      regist_info:{
        accept_image_url: "",
        accept_number: ""     
      },
    }
  },
  methods: {
    isEmpty: function(str) {
        return (!str || 0 === str.length);
    },
    async uploadFile(event){
      this.styleA = true;
      this.styleB = false;
      const files = event.target.files ? event.target.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = event => {
        this.isAccept = true
        this.accept_image = event.target.result;
        
      };
      this.accept_name = file.name;
      if(this.accept_name.match(/pdf/g) == null){
        reader.readAsDataURL(file);
      }else{
        reader.readAsDataURL(file);
        this.accept_url = URL.createObjectURL(file)
        this.accept_image = URL.createObjectURL(file)
      }
      document.getElementById('accept').files = files;
    },
    async regist(){
      await this.$refs.obs.validate().then(value =>{
        if(value){
          this.regist_info['sub'] = this.memberInfo.sub
          var regist = {}
          if(this.accept_image == ''){
            regist = {user: this.regist_info}
          }else{
            regist = {user: this.regist_info, accept_image: this.accept_image}
          }
          // this.fileValid = false
          axios
            .patch(process.env.VUE_APP_API + "/users/" + this.memberInfo.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(response => {
              this.$store.commit('user/setUser', response.data)
              this.$swal.fire({
                icon: 'success',
                title: this.$i18n.t('message.change_success')
              })
            }).catch(error => {
              console.log('this is error', error)
            })
        }
      }).catch(error => {
        console.log(error)
      })
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.outh,
      memberInfo: state => state.user.user
    }),
  },
  mounted(){
    this.$store.commit('setLoading', false)
    this.accept_image = this.memberInfo.accept_image_url
    this.regist_info.accept_number = this.memberInfo.accept_number
  },

}
</script>

<style scoped lang="scss">
.commonStyle{ 
  padding: 2rem;
  text-align:center;
}
.styleA{
  border:3px dotted gray;
  background-color: #F5F5F8 !important;
  background-size: contain !important;
  background-repeat : no-repeat !important;
}
.styleB{
  border:3px dotted rgba(0,200,0,0.7);
}
.isImage{
  background-position: center !important;
  min-height: 350px;
}
</style>
